// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeResultsGetByRoundBody = {
  poolId: string;
  contestId: string;
  roundId: string;
};

export type typeResultsGetByRoundOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    games: {
      eventId: string;
      homeTeamId: string;
      awayTeamId: string;
      result?: "homeWin" | "awayWin" | "tie" | null;
      picks: {
        entryId: string;
        displayName: string;
        teamId: string;
        outcome: "win" | "loss" | "push" | "pending";
        isViewer: boolean;
      }[];
    }[];
    correctedAt?: string | null;
    correctionDecision?: string | null;
    nonPickers: {
      entryId: string;
      userId: string;
      displayName: string;
      isViewer: boolean;
      participation: "missed" | "skipped";
    }[];
  };
};

export type typeResultsGetByRoundOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeResultsGetByRoundOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeResultsGetByRoundOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaResultsGetByRoundBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
    roundId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "contestId", "roundId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createResultsGetByRound(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaResultsGetByRoundBody);
  }

  return async function postResultsGetByRound(
    payload: typeResultsGetByRoundBody,
  ): Promise<typeResultsGetByRoundOutput200 | typeResultsGetByRoundOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postResultsGetByRound" failed before calling the network. #09b27cf88244`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#09b27cf88244" },
        },
        data: null,
      } as typeResultsGetByRoundOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/results/get-by-round`,
      httpMethod: "POST",
      options,
    })) as typeResultsGetByRoundOutput200 | typeResultsGetByRoundOutput400;
  };
}
